export const sprintTaskPriorities = [
  { id: 1, priority: "low" },
  { id: 2, priority: "medium" },
  { id: 3, priority: "high" },
];
